import { useNavigate } from 'react-router-dom';

import userSVG from '../../../images/User/user.svg';
import logoutSVG from '../../../images/User/logout.svg';

import './ActiveUser.scss';

export default function ActiveUser() {
    const navigate = useNavigate();

    const logout = () => {
        document.cookie = 'token=; Max-Age=-99999999;';
        sessionStorage.clear();
        navigate("/");
        window.location.reload();
    };

    return (
        <p className='ActiveUser'>
            <span className='ActiveUser__user'>
                <span>{sessionStorage.getItem('access-type') ?? "Social Care Coordinator"}</span>
            </span>
            <img className='ActiveUser__avatar' src={userSVG} alt='User Avatar' />
            <img className='ActiveUser__logout' src={logoutSVG} alt='Logout' title='Logout' onClick={logout} />
        </p>
    );
}